import { treaty } from "@elysiajs/eden/treaty2";
import type { ServerAppType } from "@server/server";

// Eden's treaty client requires an absolute URL, so we always resolve to one.
const resolveApiUrl = (value: string): string => {
	const isLocalHost = (h: string) => h === "localhost" || h === "127.0.0.1";
	const pageIsLocal = isLocalHost(window.location.hostname);

	// Relative path (e.g. "/api"): resolve against the current origin. A bare
	// "/api" would otherwise be mangled by treaty into "https:///api".
	if (value.startsWith("/")) return `${window.location.origin}${value}`;

	// Absolute dev URL (localhost:3001) accidentally baked into a deployed,
	// non-localhost build: fall back to same-origin /api so the call isn't
	// blocked as mixed content / cross-origin.
	try {
		if (isLocalHost(new URL(value).hostname) && !pageIsLocal) {
			return `${window.location.origin}/api`;
		}
	} catch {}

	return value;
};

const API_URL = resolveApiUrl(import.meta.env.PUBLIC_SERVER_URL || "/api");
const fetchWithAuth: typeof fetch = async (input, init) => {
	const response = await fetch(input, { ...init, credentials: "include" });

	if (
		response.status === 401 &&
		!new URL(response.url).pathname.startsWith("/auth")
	) {
		window.location.href = "/login";
	}

	return response;
};

// @ts-expect-error - Eden treaty type inference
export const api = treaty<ServerAppType>(API_URL, {
	fetcher: fetchWithAuth,
});

export const SERVER_URL = API_URL;
